/**
 * @generated SignedSource<<71505c10c5bc6adf3f2e8d25c23b03c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignTxnNatureInputObject = {
  expenseNatureId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type walletLedgerCells_AssignNatureMutation$variables = {
  input: AssignTxnNatureInputObject;
};
export type walletLedgerCells_AssignNatureMutation$data = {
  readonly assignTxnNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type walletLedgerCells_AssignNatureMutation = {
  response: walletLedgerCells_AssignNatureMutation$data;
  variables: walletLedgerCells_AssignNatureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletLedgerCells_AssignNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletLedgerCells_AssignNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "74e9706550f712b380fa5ddc264f2e9a",
    "id": null,
    "metadata": {},
    "name": "walletLedgerCells_AssignNatureMutation",
    "operationKind": "mutation",
    "text": "mutation walletLedgerCells_AssignNatureMutation(\n  $input: AssignTxnNatureInputObject!\n) {\n  assignTxnNature(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fed2970597d32a99de6228d8f7a1d8f";

export default node;
